import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { useUserSelector } from '@occc-app/App/AppContext';
import { User_Role } from '@occc/graphql';
import { AppBar, AppLayoutProvider, useSidebar } from '@occc-app/design-system';
import { FooterInfoBanner } from '@occc-app/design-system/layout/AppLayout/footer-info-banner/footer-info-banner.component';
import {
  useFooterBannerContext,
  useFooterInfoBanner,
} from '@occc-app/design-system/layout/AppLayout/footer-info-banner/footer-info-banner.context';
import { FOOTER_INFO_BANNER_HEIGHT } from '@occc-app/design-system/layout/AppLayout/constants';

const READ_ONLY_INDICATOR_MESSAGE =
  'You are a read-only user. Contact your manager for edit access.';

export const DriveInsightsLayout = () => {
  const user = useUserSelector();
  const { isSidebarOpen, onSidebarOpen } = useSidebar();
  const isReadOnlyAdminRole = user?.userRole === User_Role.AdminReadOnly;

  const { entry } = useFooterBannerContext();

  useFooterInfoBanner(isReadOnlyAdminRole ? READ_ONLY_INDICATOR_MESSAGE : null);

  const isFooterBannerVisible = !!entry;

  return (
    <AppLayoutProvider>
      <Box
        sx={{
          position: 'relative',
          minHeight: '100%',
          backgroundColor: 'drive.background',
          pb: isFooterBannerVisible ? `${FOOTER_INFO_BANNER_HEIGHT}px` : 'unset',
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 2, color: 'drive.textPrimary' }}>
          <AppBar onSidebarOpen={onSidebarOpen} isSidebarOpen={isSidebarOpen} />
        </Box>

        <Outlet />

        {isFooterBannerVisible && (
          <FooterInfoBanner message={entry.message} severity={entry.severity} />
        )}
      </Box>
    </AppLayoutProvider>
  );
};
